import { MARKETPLACE_BUSINESS_LINE } from "@swiggy-private/payment-types";

export const ELIGIBLE_BLS_FOR_WEBVIEW_REFRESH = [MARKETPLACE_BUSINESS_LINE.REGULAR];

export const ENABLE_WEBVIEW_REFRESH_DO_STORAGE_KEY = "do_enable_webview_refresh";
